import { Stack } from "react-bootstrap";

const NoContent = ({message, showIcon = false, compact = false}: {message:string|undefined, showIcon?: boolean, compact?: boolean}) => {

	return (
		<div className="card-body align-items-center" style={{height: compact ? '12vh' : '20vh', display:'flex', justifyContent:'center', textAlign: 'center'}}>
			<Stack style={{alignSelf:'center'}}>
				{ showIcon && <i className="fa-solid fa-circle-check icn-green" style={{fontSize: '50px', marginBottom:10}}></i>}
				{ message ?? "No Content" }
			</Stack>
		</div>
	)
}

export default NoContent